import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    setBusy(true);
    try {
      await signup(email, password);
      toast.success("Your 14-day free trial has started.");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-slate-50">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-sm">
        <Link to="/" className="inline-block mb-6"><div className="font-display font-bold text-primary text-xl">Job Done Reviews</div></Link>
        <h1 className="font-display text-2xl font-bold mb-1">Start your free trial</h1>
        <p className="text-slate-500 mb-6 text-sm">14 days free · No credit card required</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Business email</label>
            <Input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-lg" placeholder="you@business.com" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
            <Input data-testid="signup-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-lg" placeholder="At least 6 characters" />
          </div>
          <Button data-testid="signup-submit" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-primary hover:bg-primary/90">
            {busy ? "Creating account…" : "Start free trial"}
          </Button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-6">Already have an account? <Link to="/login" className="text-primary hover:underline" data-testid="signup-to-login">Log in</Link></p>
      </Card>
    </div>
  );
}
